<template>
  <div class="filter-bar ui basic segment grid">
    <div class="ui form">
      <div class="inline field">
        <h6 class="heading-small text-muted mb-2">Search</h6>
        <div class="input-group mb-3">
          <input type="text" class="form-control autocomplete-custom" :placeholder="placeholder" @keyup.enter="doFilter"
            v-model="filterText">
          <div class="input-group-append">
            <base-dropdown v-model="searchFilter">
              <base-button slot="title" type="secondary"
                class="btn-outline-primary dropdown-toggle dropdown-toggle-split"
                style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;" />
                <a class="dropdown-item" v-if="(currentProfile == 'product_instructions')" @click.prevent="changeSearchFilter('instruction')">Instruction</a>
                <a class="dropdown-item" v-else-if="(currentProfile == 'user_access_restrictions')" @click.prevent="changeSearchFilter('user_name')">Username</a>
                <a class="dropdown-item" v-else @click.prevent="changeSearchFilter('name')"  v-if="(currentProfile != 'gift_certificates')">Name</a>
                <a class="dropdown-item" v-if="(currentProfile != 'product_instructions' && currentProfile != 'license_expiration')" @click.prevent="changeSearchFilter('code')">Code</a>
                <a class="dropdown-item" v-if="(currentProfile == 'users')" @click.prevent="changeSearchFilter('user_name')">Username</a>
                <a class="dropdown-item" v-if="(currentProfile == 'users')" @click.prevent="changeSearchFilter('employee_id')">Employee id</a>
                <a class="dropdown-item"  @click.prevent="changeSearchFilter('version')">Version</a>
                <!-- <a class="dropdown-item" @click.prevent="changeSearchFilter('refcode')">Reference Code</a> -->
                <!-- <a class="dropdown-item" v-if="(currentProfile == 'reasons')" @click.prevent="changeSearchFilter('reason_type')">Reason Type</a> -->
              </base-dropdown>
          </div>
        </div>

        <base-input v-if="(currentProfile == 'reason_types')" label="Operation">
          <select class="form-control" v-model="operation" @change="doFilter()" size="large">
            <option v-for="option in operationOptions" v-bind:value="option.key" v-bind:key="option.key">
              {{ option.value }}
            </option>
          </select>
        </base-input>

        <div v-if="currentProfile !== 'license_expiration'">
          <hr class="my-4" />
          <h6 class="heading-small text-muted mb-4">Filter by status</h6>
          <div>
            <base-radio name="0" class="mb-3" v-model="filterStatus" value="O">
              All
            </base-radio>
            <base-radio name="A" class="mb-3" v-model="filterStatus" value="A">
              Active
            </base-radio>
            <base-radio name="I" class="mb-3" v-model="filterStatus" value="I">
              Inactive
            </base-radio>
          </div>
        </div>

        <div v-if="(isRippleAdmin && currentProfile == 'sites')">
          <hr class="my-4" />
          <h6 class="heading-small text-muted mb-4">Filter by tax type</h6>
          <div>
            <base-radio name="0" class="mb-3" v-model="filterTaxType" value="O">
              All
            </base-radio>
            <base-radio name="V" class="mb-3" v-model="filterTaxType" value="V">
              VAT
            </base-radio>
            <base-radio name="X" class="mb-3" v-model="filterTaxType" value="X">
              Non-VAT
            </base-radio>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
import secureStorage from '../controllers/secureStorage'

  export default {
    data() {
      return {
        filterText: '',
        searchFilter: "name",
        placeholder: "Search by name",
        filterStatus: '0',
        filterTaxType: '0',
        operation: '',
        operationOptions: [
          { value: "ALL", key: ""},
          {value: "ABORT RECEIPT", key: "ABT"},
          {value: "ITEM DISCOUNT", key: "DSC"},
          {value: "LINE VOID", key: "LVD"},
          {value: "VOID RECEIPT", key: "VOI"},
          {value: "PRICE OVERRIDE", key: "OVD"},
          {value: "TRANSACTIONAL PRICE CHANGE", key: "PLC"},
          {value: "REPRINT OF RECEIPT", key: "PRN"},
          {value: "RETURN", key: "RET"},
          {value: "TAX CHANGE", key: "TAX"},
          {value: "BARCODE PRINTING", key: "BCD"},
          {value: "WITHDRAWAL", key: "WIT"},
          {value: "DEPOSIT", key: "DEP"},
          {value: "REFUND", key: "REF"},
          {value: "CHANGE QUANTITY", key: "QTY"},
          {value: "ON-US", key: "ONUS"}
        ],
        isRippleAdmin: secureStorage.getItem("isRippleAdmin")
      }
    },
    computed: {
      ...mapState(['currentProfile']),
    },
    watch: {
      filterStatus: function () {
        // eslint-disable-next-line
        // console.log(this.filterStatus)
        // changeFilter(statusFilter, searchFilter, searchText)
        let filterText = this.filterText
        if(this.currentProfile == 'reason_types' && this.operation != ""){
          filterText = filterText + "&" + "operation_type=" + this.operation
        }
        this.$emit('changeFilter', this.filterStatus, this.searchFilter, filterText)
      },
      filterTaxType: function () {
        // eslint-disable-next-line
        this.$emit('changeFilter', this.filterStatus, this.searchFilter, this.filterText, this.filterTaxType)
      },
      currentProfile: function (value) {
        switch (value) {
          case 'product_instructions':
            this.placeholder = 'Search by instruction'
            this.searchFilter = 'instruction'
            break
          case 'user_access_restrictions':
            this.placeholder = 'Search by username'
            this.searchFilter = 'user_name'
            break
          default:
            this.placeholder = 'Search by name'
            this.searchFilter = 'name'
            break
        }
      }
    },
    methods: {
      changeSearchFilter(searchFilter) {
        this.searchFilter = searchFilter;
        switch (searchFilter) {
          case "operation_type":
            this.placeholder = "Search by operation";
            break;
          case "user_name":
            this.placeholder = "Search by user name";
            break;
          case "employee_id":
            this.placeholder = "Search by employee id";
            break;
          default:
            this.placeholder = "Search by " + searchFilter;
        }
      },
      doFilter() {
        let filterText = this.filterText
        if(this.currentProfile == 'reason_types' && this.operation != ""){
          filterText = filterText + "&" + "operation_type=" + this.operation
        } else if (this.currentProfile == 'product_instructions') {
          this.searchFilter = 'instruction'
        }
        this.$emit('changeFilter', this.filterStatus, this.searchFilter, filterText)
      }
    }
  }
</script>

<style>
  .autocomplete-custom {
      height: 43px !important;
  }
</style>
